#import "~/graphql/fragments/pageContent/postCardsContent.graphql"

fragment flexiblePostsSliderManualSelect on flexibleSections_postsSliderManualSelect_BlockType {
    __typename
    title: plaintext
    description: richTextMinimal
    posts: selectPosts {
       ...postCardsContent
    }
}
